export const getStateValues = (
  viewState,
  setViewState,
  viewStateMethods = null
) => ({
  ...viewState,
  updateViewState: (viewStateUpdate) =>
    setViewState((prev) => ({ ...prev, ...viewStateUpdate })),
  ...(typeof viewStateMethods === "function"
    ? viewStateMethods(viewState, setViewState)
    : {}),
});
